import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { State } from '../../store/reducer';

import * as ArticlesActions from '../../store/actions';
import { Filter } from '../../models/filter.model';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-group-four',
  templateUrl: './group-four.component.html',
  styleUrls: ['./group-four.component.scss']
})
export class GroupFourComponent implements OnInit {
  allGroups: any[] = [];
  query = '';

  parent = { Name: '', Id: 0 };   // Group2
  viewValue = { Name: '', Id: 0 };// Group3

  @Input() isMobile: boolean;

  private app = Filter.getAggregationAndId('app');
  maxNumber = environment.defaultItemsNumber;
  private defaultMaxNumber = environment.defaultItemsNumber;
  showMoreButton = true;
  showLessButton = false;

  constructor(
    private store: Store<State>,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.store.select('articles').subscribe((state: any) => {
      if (state.loadedArticles) {
        const agg = state.result.Aggregations.ArticleGroupAggregationItem;

        if (!state.togglingSidenav && agg.BaseItems.length !== 0 && agg.AggregationLevel === 4) {
          this.app = Filter.getAggregationAndId('app');

          if (!state.filters.Group3.Name) {
            const firstItem = agg.BaseItems[0];
            const group2 = Filter.getValue('Group2');

            if (agg.BaseItems.length === 1 && firstItem.Parent && firstItem.Parent.Id === group2.Id) {
              Filter.setFilterFromItemProper(state, 'Group3', 'groups');
              Filter.setFilterFromItemParent(state, 'Group2', 'groups');
            } else {
              Filter.setFilterFromItemParent(state, 'Group3', 'groups');
              Filter.setFilterFromItemGrandParent(state, 'Group2', 'groups');
            }
          }

          this.parent = Filter.getValue('Group2');
          this.viewValue = Filter.getValue('Group3');

          if (Filter.Offset === 0) {
            const selectedId = Filter.getValue('Group3').Id;
            this.allGroups = agg.BaseItems.filter(item => item.Id !== selectedId);

            this.maxNumber = this.defaultMaxNumber;
            if (this.allGroups.length < this.maxNumber) {
              this.maxNumber = this.allGroups.length;
            }
          }

          this.showMoreButton = true;
          this.hideExtensionButtons();

          Filter.resetValue('Group6');
          Filter.resetValue('Group5');
          Filter.resetValue('Group4');

          this.store.dispatch({
            type: ArticlesActions.ActionTypes.CHANGE_FILTERS,
            payload: { filters: Filter }
          });
        }
      }
    });
  }

  navigateUp() {
    if (Filter.Query.length) {
      this.router.navigate(
        [Filter.Query.join(' '), this.app.lvl, this.app.id, '3', this.parent.Id],
        { relativeTo: this.route.parent }
      );
    } else {
      this.router.navigate(
        [this.app.lvl, this.app.id, '3', this.parent.Id],
        { relativeTo: this.route.parent }
      );
    }
  }

  navigateDown(item: any) {
    if (Filter.Query.length) {
      this.router.navigate(
        [Filter.Query.join(' '), this.app.lvl, this.app.id, '5', item.Id],
        { relativeTo: this.route.parent }
      );
    } else {
      this.router.navigate(
        [this.app.lvl, this.app.id, '5', item.Id],
        { relativeTo: this.route.parent }
      );
    }
  }

  showMore(show: boolean) {
    if (show) {
      this.maxNumber = this.allGroups.length;
    } else {
      this.maxNumber = this.defaultMaxNumber;
    }
    this.showLessButton = show;
    this.showMoreButton = !show;
    this.hideExtensionButtons();
  }

  hideExtensionButtons() {
    if (this.allGroups.length <= this.maxNumber) {
      this.maxNumber = this.allGroups.length;
      this.showMoreButton = false;
      this.showLessButton = false;
    }
  }
}
